import axiosapi from "./axiosAPI";

// Get All Rights
export const getAllRights = async (
    setRights,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/rights");
        setRights(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Rights");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Rights");
		}
		
	}
	
};



// Get All Rights Per Country
export const getBroadCategoryRights = async (
    setRights,
    setFetcherror,
    pkid
) => {
    
	try{
		const res =await axiosapi.get(`/broadcategoryrights/${pkid}`);
        setRights(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Rights");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Rights");
		}
		
	}
	
};



// Get One Right
export const getOneRight = async (
    pkid,
    setFetcherror,  
    setRight
    
)=>{
	try{
		const res =await axiosapi.get(`/rights/${pkid}`);
        setRight(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Right");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Right");
		}
		
	}
	
};


// Create New Right
export const createRight = async (
    right,
    pkid,
    setRight,
    setFetcherror,
    handleAllToasts,
    setRights

) => {

    

    if (!right) {
        handleAllToasts(2, "No Right Provided"); 
            return; 
        }

    const PushItem = {
        name: right,
        broadcategory_id:pkid
        };

    try{
        await axiosapi.post("/rights/",PushItem );
        setRight("");
        handleAllToasts(1, "Right Created Successfully");
        getAllRights(setRights, setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Right");
            handleAllToasts(2, "Could Not update The Right");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Right");
            handleAllToasts(2, "Could Not update The Right");
            
        }
        
    }
    
}


// Edit Existing Right

export const editRight = async (
    pkid,
    right,
    setRight,
    setFetcherror,
    handleAllToasts,
    setRights
              
        ) => {

            if (!right) {
                handleAllToasts(2, "No Right Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:pkid,
                    name: right,
                };

            try{
                await axiosapi.patch("/rights/",PushItem );
                setRight("");
                handleAllToasts(1, "Right Updated Successfully");
                getAllRights(setRights, setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Right");
                    handleAllToasts(2, "Could Not Update Right");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Right");
                    handleAllToasts(2, "Could Not Update Right");
                    
                }
                
            }
            
};



// Delete Existing Right.

export const deleteRight = async (
    pkid,
    setcountries,
    setFetcherror,
    handleAllToasts,
    setRights
)=>{
    try {
        const res = await axiosapi.delete(`/rights/${pkid}`);
        let finalData = res.data.message;
        getAllRights(setcountries, setFetcherror);
        handleAllToasts(1, "Right Deleted Successfully");
        getAllRights(setRights, setFetcherror);
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Right");
            handleAllToasts(2,"Error: Could Not Delete Right");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Right");
            handleAllToasts(2,"Error: Could Not Delete Right");
		}
		
	}
	
};